<template>
  <div class="container">
      
    
    <div style="height: 60px"></div>
    <div class="rl-box flex">
      <div class="week-box">
        <div v-for="(v, i) in weeks" :key="v.time"  :class="`week ${i === week_index ? 'on' : ''}`" @click="week_index = i">
          {{v.name}}（{{formatTime(v.time, "MM-DD")}}）
        </div>
      </div>
      <div class="items flex" v-loading="loading">
        <div class="item" v-for="v in listData" :key="v.id" @click="openInfo(v)">
          <el-image 
            style="width: 286px; height: 156px"
            :src="isHead(v.imgpath1)" 
            fit="cover"
            >
            <el-image 
              style="width: 286px; height: 156px"
              :src="isHead()" 
              fit="cover">
            </el-image>
          </el-image>
          <div class="info-box">
            <div class="title ellipsis_2">{{v.title}}</div>
            <div class="time txt">{{isState(v)}}</div>
            <div class="click txt">观看人数：{{v.click}}人</div>
            <div class="source txt ellipsis">来源：{{v.source}}</div>
            <div class="more flex">
              <div class="tip">查看详情</div>
              <div class="icon">
                <img :src="require('@/assets/5101/icon_5.png')" alt="">
              </div>
            </div>
          </div>
        </div>
        <el-empty description="暂无内容" v-if="!listData && !loading" />
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, watch } from "vue"
import { formatTime, isHead, count_down } from "@/tools"
import { openInfo } from "@/tools/jump"
import { api } from "@/api"
export default {
  name: "calendar",
  setup() {
    let initData = reactive({
      week_index: 0,
      weeks: [
        { name: '周一', time: "" },
        { name: '周二', time: "" },
        { name: '周三', time: "" },
        { name: '周四', time: "" },
        { name: '周五', time: "" },
        { name: '周六', time: "" },
        { name: '周日', time: "" },
      ],
      loading: false,
      listData: "",

      serverTime: "",
      countDown: ""
    })
    let nowDay = new Date().getDay()
    let timestamp = +new Date()
    initData.weeks[nowDay - 1].isToday = true
    initData.weeks.forEach((item, index) => {
      initData.weeks[index].time = timestamp + 24 * 60 * 60 * 1000 * (index - (nowDay + 6) % 7)
      if(index - (nowDay + 6) % 7 === 0) {
        initData.week_index = index
        getList(initData.weeks[index].time)
      }
    })
    watch(() => initData.week_index, newVal => {
      getList(initData.weeks[newVal].time)
      getServerTime()
    })
    function getList(time) {
      let data = {
        time: formatTime(time, "YYYYMMDD"),
        pageNum: 1,
        pageSize: 3,
        appcode: ""
      }
      initData.loading = true
      api("get", "getCalendarByTime", data)
        .then(res => {
          initData.loading = false
          if(res.code === 1200) {
            initData.listData = res.data
          }
        })
        .catch(err => {
          initData.loading = false
        })
    }
    // 获取服务器时间
    function getServerTime() {
      api("get", "getSystemTime").then(res => {
        if(res.code === 1200) {
          initData.serverTime = res.data
        }
      })
    }
    getServerTime()
    // 活动时间判断
    function isState(row) {
      let now_time = initData.serverTime || +new Date()
      if(row.type == 8) {
        if(row.servstarttime > now_time) {
          return "距离投票开始：" + count_down(row.servstarttime - now_time)
        }
        if(row.servstarttime < now_time && row.servendtime > now_time) {
          return "距离投票截止：" + count_down(row.servendtime - now_time)
        }
        if(row.servendtime < now_time) {
          return "投票已截止"
        }

      } else {
        if(row.getsarttime > now_time) {
          return "距离报名开始：" + count_down(row.getsarttime - now_time)
        }
        if(row.getsarttime < now_time && row.getendtime > now_time) {
          return "距离报名截止：" + count_down(row.getendtime - now_time)
        }
        if(row.servstarttime < now_time && row.servendtime > now_time) {
          return "报名已截止"
        }
        if(row.servendtime < now_time) {
          return "活动已结束"
        }
      }
      
    }
    return {
      ...toRefs(initData),
      formatTime,
      isState,
      isHead,
      openInfo,
    }
  }
}
</script>

<style lang="less" scoped>


.rl-box {
  .week-box {
    .week {
      color: #DFDFDF;
      margin-bottom: 40px;
      font-size: 18px;
      line-height: 1;
      cursor: pointer;
      &:hover {
        color: #10BB58;
      }
    }
    .week.on {
      font-size: 24px;
      font-weight: bold;
      color: white;
      position: relative;
      padding-left: 27px;
      height: 48px;
      &::before {
        content: "";
        width: 7px;
        height: 48px;
        background-color: #10BB58;
        position: absolute;
        left: 0;
        top: 0;
      }
      &::after {
        content: "";
        height: 8px;
        width: 70px;
        background-image: url('~@/assets/5101/icon_6.png');
        background-size: 100%;
        position: absolute;
        left: 27px;
        bottom: 0;
      }
    }
  }
  .items {
    margin-left: 90px;
    width: 920px;
    .item {
      width: 286px;
      height: 396px;
      background-color: #0E2F56;
      margin: 0 10px;
      transition: 0.2s;
      cursor: pointer;
      &:hover {
        transform: scale(1.05);
        background-color: white;
        .info-box {
          .title {
            color: #0A1E37;
            font-weight: bold;
          }
          .txt {
            color: #0F3157;
          }
          .more {
            opacity: 1;
          }
        }
      }
      .info-box {
        padding: 20px;
        box-sizing: border-box;
        .title {
          font-size: 18px;
          font-weight: 500;
          color: white;
        }
        .time {
          font-size: 14px;
          color: #96BDE2;
          margin-top: 20px;
        }
        .click,.source {
          font-size: 14px;
          color: white;
          opacity: .6;
          margin-top: 12px;
        }
        .more {
          margin-top: 23px;
          align-items: center;
          line-height: 1;
          opacity: 0;
          .tip {
            color: #10BB58;
            font-size: 14px;
          }
          .icon {
            font-size: 0;
            margin-left: 7px;
            display: flex;
            align-items: center;
          }
        }
      }
    }
  }
}
:deep(.el-empty) {
  width: 100%;
}
</style>